import React, { useState } from 'react';
import ErrorBoundary from '../../../components/ErrorBoundary';
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faPlus, faTimes, faSave, faCheck, faXmark, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import './style.css';

interface Contato {
  id: number;
  nome: string;
  cargo: string;
  email: string;
  telefone: string;
  celular?: string;
  recebe_email_cessao: boolean;
  assina_termo: boolean;
}

interface Fundo {
  id: number;
  nome: string;
  cnpj: string;
  ativo: boolean;
  id_header_cnab: string;
  id_cnab: string;
  modelo_termo: number;
}

interface Cedente {
  razao_social: string;
  nome_fantasia: string;
  cnpj: string;
  ativo: boolean;
  contatos: Contato[];
  fundos: Fundo[];
}

const CadastroCedente = () => {
  const [modais, setModais] = useState({
    contatos: false,
    edicao: false,
    fundos: false,
    adicionarContato: false,
    adicionarFundo: false,
    novoCedente: false,
    edicaoContato: false,
    edicaoFundo: false,
    confirmacaoSaida: false
  });

  const [dadosModais, setDadosModais] = useState({
    cedenteSelecionado: null as Cedente | null,
    cedenteParaEdicao: null as Cedente | null,
    cedenteFundos: null as Cedente | null,
    novoContato: {
      nome: '',
      cargo: '',
      email: '',
      telefone: '',
      celular: ''
    },
    novoFundo: {
      fundo_id: 0,
      id_header_cnab: '',
      id_cnab: '',
      modelo_termo: 1,
      ativo: true
    },
    dadosEdicao: {
      razao_social: '',
      nome_fantasia: '',
      cnpj: '',
      ativo: true
    },
    novoCedente: {
      razao_social: '',
      nome_fantasia: '',
      cnpj: '',
      ativo: true
    },
    contatosNovoCedente: [] as Array<{
      nome: string;
      telefone: string;
      email: string;
      recebe_email_cessao: boolean;
      assina_termo: boolean;
    }>,
    fundosNovoCedente: [] as Array<{
      fundo_id: number;
    }>,
    contatoParaEdicao: null as Contato | null,
    dadosEdicaoContato: {
      nome: '',
      cargo: '',
      email: '',
      telefone: '',
      celular: '',
      recebe_email_cessao: false,
      assina_termo: false
    },
    fundoParaEdicao: null as Fundo | null,
    dadosEdicaoFundo: {
      nome: '',
      cnpj: '',
      id_header_cnab: '',
      id_cnab: '',
      modelo_termo: 1,
      ativo: true
    }
  });

  const [validacaoErro, setValidacaoErro] = useState({
    cedente: {
      razao_social: false,
      nome_fantasia: false,
      cnpj: false
    },
    contatos: [] as Array<{
      nome: boolean;
      telefone: boolean;
      email: boolean;
    }>,
    fundos: [] as Array<{
      fundo_id: boolean;
    }>,
    tentouSalvar: false // Flag para saber se já tentou salvar
  });

  const [alteracoesPendentes, setAlteracoesPendentes] = useState(false);
  const [modalParaFechar, setModalParaFechar] = useState<keyof typeof modais | null>(null);

  const isAdmin = localStorage.getItem('is_admin') === 'true';

  const fundosDisponiveis = [
    { id: 1, nome: 'FIDC MULTIESTRATEGIA I', cnpj: '11.111.111/1111-11' },
    { id: 2, nome: 'FIDC MULTIESTRATEGIA II', cnpj: '22.222.222/2222-22' },
    { id: 3, nome: 'FIDC CREDITO DIRETO', cnpj: '33.333.333/3333-33' },
    { id: 4, nome: 'FIDC RECEBIVEIS', cnpj: '44.444.444/4444-44' },
    { id: 5, nome: 'FIDC CORPORATIVO', cnpj: '55.555.555/5555-55' }
  ];

  const mockData: Cedente[] = [
    {
      razao_social: 'Cartos Sociedade de Crédito Direto S.A.',
      nome_fantasia: 'Cartos',
      cnpj: '59929098000109',
      ativo: true,
      contatos: [
        {
          id: 1,
          nome: 'João Silva',
          cargo: 'Gerente Financeiro',
          email: 'joao.silva@cartos.com.br',
          telefone: '(11) 3333-4444',
          recebe_email_cessao: true,
          assina_termo: true
        },
        {
          id: 2,
          nome: 'Maria Santos',
          cargo: 'Analista de Crédito',
          email: 'maria.santos@cartos.com.br',
          telefone: '(11) 3333-5555',
          recebe_email_cessao: true,
          assina_termo: true
        }
      ],
      fundos: [
        {
          id: 1,
          nome: 'FIDC MULTIESTRATEGIA I',
          cnpj: '11.111.111/1111-11',
          ativo: true,
          id_header_cnab: '1234567890',
          id_cnab: '1234567890',
          modelo_termo: 1
        },
        {
          id: 2,
          nome: 'FIDC MULTIESTRATEGIA II',
          cnpj: '22.222.222/2222-22',
          ativo: false,
          id_header_cnab: '1234567890',
          id_cnab: '1234567890',
          modelo_termo: 1
        }
      ]
    },
    {
      razao_social: 'Viva Crédito S.A.',
      nome_fantasia: 'Viva Crédito',
      cnpj: '59929098000109',
      ativo: true,
      contatos: [
        {
          id: 3,
          nome: 'Pedro Oliveira',
          cargo: 'Diretor Comercial',
          email: 'pedro.oliveira@vivacredito.com.br',
          telefone: '(11) 4444-6666',
          recebe_email_cessao: true,
          assina_termo: true
        },
        {
          id: 4,
          nome: 'Ana Costa',
          cargo: 'Coordenadora de Operações',
          email: 'ana.costa@vivacredito.com.br',
          telefone: '(11) 4444-7777',
          recebe_email_cessao: true,
          assina_termo: true
        },
        {
          id: 5,
          nome: 'Carlos Mendes',
          cargo: 'Analista de Risco',
          email: 'carlos.mendes@vivacredito.com.br',
          telefone: '(11) 4444-8888',
          recebe_email_cessao: true,
          assina_termo: true
        }
      ],
      fundos: [
        {
          id: 1,
          nome: 'Fundo 1',
          cnpj: '59929098000109',
          ativo: true,
          id_header_cnab: '1234567890',
          id_cnab: '1234567890',
          modelo_termo: 1
        }
      ]
    },
    {
      razao_social: 'Crédito Direto S.A.',
      nome_fantasia: 'Crédito Direto',
      cnpj: '59929098000109',
      ativo: true,
      contatos: [
        {
          id: 3,
          nome: 'Pedro Oliveira',
          cargo: 'Diretor Comercial',
          email: 'pedro.oliveira@credito.com.br',
          telefone: '(11) 4444-6666',
          recebe_email_cessao: true,
          assina_termo: true
        },
        {
          id: 4,
          nome: 'Ana Costa',
          cargo: 'Coordenadora de Operações',
          email: 'ana.costa@credito.com.br',
          telefone: '(11) 4444-7777',
          recebe_email_cessao: true,
          assina_termo: true
        },
        {
          id: 5,
          nome: 'Carlos Mendes',
          cargo: 'Analista de Risco',
          email: 'carlos.mendes@credito.com.br',
          telefone: '(11) 4444-8888',
          recebe_email_cessao: true,
          assina_termo: true
        }
      ],
      fundos: [
        {
          id: 1,
          nome: 'FIDC MULTIESTRATEGIA I',
          cnpj: '59929098000109',
          ativo: true,
          id_header_cnab: '1234567890',
          id_cnab: '1234567890',
          modelo_termo: 1
        }
      ]
    }
  ];

  const abrirModal = (tipoModal: keyof typeof modais, dados?: any) => {
    setModais(prev => ({ ...prev, [tipoModal]: true }));

    if (dados) {
      setDadosModais(prev => ({
        ...prev,
        ...dados
      }));
    }
  };

  const fecharModal = (tipoModal: keyof typeof modais) => {
    setModais(prev => ({ ...prev, [tipoModal]: false }));

    if (tipoModal === 'contatos') {
      setDadosModais(prev => ({ ...prev, cedenteSelecionado: null }));
    } else if (tipoModal === 'edicao') {
      setDadosModais(prev => ({
        ...prev,
        cedenteParaEdicao: null,
        dadosEdicao: {
          razao_social: '',
          nome_fantasia: '',
          cnpj: '',
          ativo: true
        }
      }));
    } else if (tipoModal === 'fundos') {
      setDadosModais(prev => ({ ...prev, cedenteFundos: null }));
    } else if (tipoModal === 'adicionarContato') {
      setDadosModais(prev => ({
        ...prev,
        novoContato: {
          nome: '',
          cargo: '',
          email: '',
          telefone: '',
          celular: ''
        }
      }));
    } else if (tipoModal === 'adicionarFundo') {
      setDadosModais(prev => ({
        ...prev,
        novoFundo: {
          fundo_id: 0,
          id_header_cnab: '',
          id_cnab: '',
          modelo_termo: 1,
          ativo: true
        }
      }));
    } else if (tipoModal === 'novoCedente') {
      setDadosModais(prev => ({
        ...prev,
        novoCedente: {
          razao_social: '',
          nome_fantasia: '',
          cnpj: '',
          ativo: true
        },
        contatosNovoCedente: [],
        fundosNovoCedente: []
      }));
    } else if (tipoModal === 'edicaoContato') {
      setDadosModais(prev => ({
        ...prev,
        contatoParaEdicao: null,
        dadosEdicaoContato: {
          nome: '',
          cargo: '',
          email: '',
          telefone: '',
          celular: '',
          recebe_email_cessao: false,
          assina_termo: false
        }
      }));
    } else if (tipoModal === 'edicaoFundo') {
      setDadosModais(prev => ({
        ...prev,
        fundoParaEdicao: null,
        dadosEdicaoFundo: {
          nome: '',
          cnpj: '',
          id_header_cnab: '',
          id_cnab: '',
          modelo_termo: 1,
          ativo: true
        }
      }));
    }
  };

  const abrirModalContatos = (cedente: Cedente) => {
    abrirModal('contatos', { cedenteSelecionado: cedente });
  };

  const abrirModalEdicao = (cedente: Cedente) => {
    abrirModal('edicao', {
      cedenteParaEdicao: cedente,
      dadosEdicao: {
        razao_social: cedente.razao_social,
        nome_fantasia: cedente.nome_fantasia,
        cnpj: cedente.cnpj,
        ativo: cedente.ativo
      }
    });
  };

  const abrirModalFundos = (cedente: Cedente) => {
    abrirModal('fundos', { cedenteFundos: cedente });
    setAlteracoesPendentes(false);
  };

  const abrirModalAdicionarContato = () => {
    abrirModal('adicionarContato');
  };

  const abrirModalAdicionarFundo = () => {
    abrirModal('adicionarFundo');
  };

  const abrirModalNovoCedente = () => {
    abrirModal('novoCedente');
  };

  const abrirModalEdicaoContato = (contato: Contato) => {
    abrirModal('edicaoContato', {
      contatoParaEdicao: contato,
      dadosEdicaoContato: {
        nome: contato.nome,
        cargo: contato.cargo,
        email: contato.email,
        telefone: contato.telefone,
        celular: contato.celular || '',
        recebe_email_cessao: contato.recebe_email_cessao,
        assina_termo: contato.assina_termo
      }
    });
  };

  const abrirModalEdicaoFundo = (fundo: Fundo) => {
    abrirModal('edicaoFundo', {
      fundoParaEdicao: fundo,
      dadosEdicaoFundo: {
        nome: fundo.nome,
        cnpj: fundo.cnpj,
        id_header_cnab: fundo.id_header_cnab,
        id_cnab: fundo.id_cnab,
        modelo_termo: fundo.modelo_termo,
        ativo: fundo.ativo
      }
    });
  };

  const salvarEdicao = () => {
    if (dadosModais.cedenteParaEdicao) {
      console.log('Salvando edição:', dadosModais.dadosEdicao);
      fecharModal('edicao');
    }
  };

  const salvarNovoContato = () => {
    if (dadosModais.cedenteSelecionado) {
      const novoId = Math.max(...dadosModais.cedenteSelecionado.contatos.map(c => c.id)) + 1;
      const contatoCompleto = {
        ...dadosModais.novoContato,
        id: novoId
      };
      console.log('Adicionando novo contato:', contatoCompleto);
      fecharModal('adicionarContato');
    }
  };

  const salvarNovoFundo = () => {
    if (dadosModais.cedenteFundos && dadosModais.novoFundo.fundo_id !== 0) {
      const fundoSelecionado = fundosDisponiveis.find(f => f.id === dadosModais.novoFundo.fundo_id);
      if (fundoSelecionado) {
      const novoId = Math.max(...dadosModais.cedenteFundos.fundos.map(f => f.id)) + 1;
      const fundoCompleto = {
        id: novoId,
          nome: fundoSelecionado.nome,
          cnpj: fundoSelecionado.cnpj,
          ativo: dadosModais.novoFundo.ativo,
          id_header_cnab: dadosModais.novoFundo.id_header_cnab,
          id_cnab: dadosModais.novoFundo.id_cnab,
          modelo_termo: dadosModais.novoFundo.modelo_termo
      };
      console.log('Adicionando novo fundo:', fundoCompleto);
      fecharModal('adicionarFundo');
      }
    }
  };

  const salvarEdicaoContato = () => {
    if (dadosModais.contatoParaEdicao) {
      console.log('Salvando edição do contato:', dadosModais.dadosEdicaoContato);
      fecharModal('edicaoContato');
    }
  };

  const salvarEdicaoFundo = () => {
    if (dadosModais.fundoParaEdicao) {
      console.log('Salvando edição do fundo:', dadosModais.dadosEdicaoFundo);
      fecharModal('edicaoFundo');
    }
  };

  const toggleStatusFundo = (fundoId: number) => {
    if (dadosModais.cedenteFundos) {
      const fundosAtualizados = dadosModais.cedenteFundos.fundos.map(fundo =>
        fundo.id === fundoId ? { ...fundo, ativo: !fundo.ativo } : fundo
      );

      setDadosModais(prev => ({
        ...prev,
        cedenteFundos: {
          ...prev.cedenteFundos!,
          fundos: fundosAtualizados
        }
      }));

      setAlteracoesPendentes(true); 
    }
  };

  const salvarAlteracoesFundos = () => {
    if (dadosModais.cedenteFundos) {
      console.log('Salvando alterações dos fundos:', dadosModais.cedenteFundos.fundos);
      // Aqui você pode implementar a lógica para salvar no backend
      setAlteracoesPendentes(false); // Reset das alterações pendentes
      fecharModal('fundos');
    }
  };

  const fecharModalComConfirmacao = (tipoModal: keyof typeof modais) => {
    if (tipoModal === 'fundos' && alteracoesPendentes) {
      setModalParaFechar(tipoModal);
      setModais(prev => ({ ...prev, confirmacaoSaida: true }));
    } else {
      fecharModal(tipoModal);
    }
  };

  const confirmarSaida = () => {
    if (modalParaFechar === 'fundos') {
      salvarAlteracoesFundos();
    }
    setModais(prev => ({ ...prev, confirmacaoSaida: false }));
    setModalParaFechar(null);
  };

  const descartarAlteracoes = () => {
    if (modalParaFechar === 'fundos') {
      setAlteracoesPendentes(false);
      fecharModal(modalParaFechar);
    }
    setModais(prev => ({ ...prev, confirmacaoSaida: false }));
    setModalParaFechar(null);
  };

  const salvarNovoCedente = () => {
    // Marcar que tentou salvar
    setValidacaoErro(prev => ({ ...prev, tentouSalvar: true }));

    // Validação dos campos obrigatórios
    const cedenteValido = validarCedente();
    const contatosValidos = validarContatos();
    const fundosValidos = validarFundos();

    if (cedenteValido && contatosValidos && fundosValidos) {
      console.log('Criando novo cedente:', {
        cedente: dadosModais.novoCedente,
        contatos: dadosModais.contatosNovoCedente,
        fundos: dadosModais.fundosNovoCedente
      });
      fecharModal('novoCedente');
    } else {
      // Definir erros de validação visual
      const novosErros = {
        cedente: {
          razao_social: dadosModais.novoCedente.razao_social.trim() === '',
          nome_fantasia: dadosModais.novoCedente.nome_fantasia.trim() === '',
          cnpj: dadosModais.novoCedente.cnpj.trim() === ''
        },
        contatos: dadosModais.contatosNovoCedente.map(contato => ({
          nome: contato.nome.trim() === '',
          telefone: contato.telefone.trim() === '',
          email: contato.email.trim() === ''
        })),
        fundos: dadosModais.fundosNovoCedente.map(fundo => ({
          fundo_id: fundo.fundo_id === 0
        })),
        tentouSalvar: true
      };

      setValidacaoErro(novosErros);
    }
  };

  const validarCedente = () => {
    const { razao_social, nome_fantasia, cnpj } = dadosModais.novoCedente;
    return razao_social.trim() !== '' && nome_fantasia.trim() !== '' && cnpj.trim() !== '';
  };

  const validarContatos = () => {
    if (dadosModais.contatosNovoCedente.length === 0) {
      return false; // Pelo menos um contato é obrigatório
    }

    return dadosModais.contatosNovoCedente.every(contato =>
      contato.nome.trim() !== '' &&
      contato.telefone.trim() !== '' &&
      contato.email.trim() !== ''
    );
  };

  const validarFundos = () => {
    if (dadosModais.fundosNovoCedente.length === 0) {
      return false; // Pelo menos um fundo é obrigatório
    }

    return dadosModais.fundosNovoCedente.every(fundo =>
      fundo.fundo_id !== 0
    );
  };

  const adicionarContatoNovoCedente = () => {
    setDadosModais(prev => ({
      ...prev,
      contatosNovoCedente: [
        ...prev.contatosNovoCedente,
        {
          nome: '',
          telefone: '',
          email: '',
          recebe_email_cessao: false,
          assina_termo: false
        }
      ]
    }));
  };

  const removerContatoNovoCedente = (index: number) => {
    setDadosModais(prev => ({
      ...prev,
      contatosNovoCedente: prev.contatosNovoCedente.filter((_, i) => i !== index)
    }));
  };

  const atualizarContatoNovoCedente = (index: number, field: string, value: string | boolean) => {
    setDadosModais(prev => ({
      ...prev,
      contatosNovoCedente: prev.contatosNovoCedente.map((contato, i) =>
        i === index ? { ...contato, [field]: value } : contato
      )
    }));
  };

  const adicionarFundoNovoCedente = () => {
    setDadosModais(prev => ({
      ...prev,
      fundosNovoCedente: [
        ...prev.fundosNovoCedente,
        {
          fundo_id: 0
        }
      ]
    }));
  };

  const removerFundoNovoCedente = (index: number) => {
    setDadosModais(prev => ({
      ...prev,
      fundosNovoCedente: prev.fundosNovoCedente.filter((_, i) => i !== index)
    }));
  };

  const atualizarFundoNovoCedente = (index: number, field: string, value: string | number) => {
    setDadosModais(prev => ({
      ...prev,
      fundosNovoCedente: prev.fundosNovoCedente.map((fundo, i) =>
        i === index ? { ...fundo, [field]: value } : fundo
      )
    }));
  };

  const isFundoSelecionado = (fundoId: number, currentIndex: number) => {
    return dadosModais.fundosNovoCedente.some((fundo, index) =>
      index !== currentIndex && fundo.fundo_id === fundoId
    );
  };

  const isFundoJaAdicionado = (fundoId: number) => {
    if (!dadosModais.cedenteFundos) return false;
    return dadosModais.cedenteFundos.fundos.some(fundo => fundo.id === fundoId);
  };

  const handleInputChange = (tipo: 'edicao' | 'contato' | 'fundo' | 'novoCedente', field: string, value: string | boolean) => {
    const key = tipo === 'novoCedente' ? 'novoCedente' : `dados${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`;
    setDadosModais(prev => ({
      ...prev,
      [key]: {
        ...prev[key as keyof typeof prev],
        [field]: value
      }
    }));
  };

  const ModelosTermo = [
    { id: 1, nome: 'Click' },
    { id: 2, nome: 'D4Sign' },
    { id: 3, nome: 'Não aplicável' }
  ];

  return (
    <ErrorBoundary>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h5 className="card-title">Cadastro de Cedentes</h5>
        {isAdmin && (
          <button
            className="fn-button fn-button--emphasized"
            onClick={abrirModalNovoCedente}
          >
            <div className="fn-button__text">
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
              Novo Cedente
            </div>
          </button>
        )}
      </div>
      <Table>
        <thead>
          <tr>
            <th>CNPJ</th>
            <th>Razão Social</th>
            <th>Nome Fantasia</th>
            <th>Situação</th>
            <th>Fundos</th>
            <th>Contatos</th>
            {isAdmin && <th>Editar</th>}
          </tr>
        </thead>
        <tbody>
          {mockData.map((item, index) => (
            <tr key={index}>
              <td>{item.cnpj}</td>
              <td>{item.razao_social}</td>
              <td>{item.nome_fantasia}</td>
              <td>
                <span className={`badge ${item.ativo ? 'ativo' : 'inativo'}`}>
                  {item.ativo ? 'Ativo' : 'Inativo'}
                </span>
              </td>
              <td>
                <button
                  className="fn-button fn-button--icon fn-button--secondary"
                  onClick={() => abrirModalFundos(item)}
                  title="Ver fundos"
                >
                  <div className="fn-button__text">
                    <FontAwesomeIcon icon={faEye} />
                  </div>
                </button>
              </td>
              <td>
                <button
                  className="fn-button fn-button--icon fn-button--secondary"
                  onClick={() => abrirModalContatos(item)}
                  title="Ver contatos"
                >
                  <div className="fn-button__text">
                    <FontAwesomeIcon icon={faEye} />
                  </div>
                </button>
              </td>
              <td>
                {isAdmin && (
                  <button
                    className="fn-button fn-button--icon fn-button--secondary"
                    onClick={() => abrirModalEdicao(item)}
                    title="Editar cedente"
                  >
                    <div className="fn-button__text">
                      <FontAwesomeIcon icon={faEdit} />
                    </div>
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {modais.contatos && dadosModais.cedenteSelecionado && (
        <div className="modal-overlay" onClick={() => fecharModal('contatos')}>
          <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                Contatos - {dadosModais.cedenteSelecionado.nome_fantasia}
              </h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('contatos')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <Table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Telefone</th>
                    <th>Email</th>
                    <th>Recebe Email de Cessão</th>
                    <th>Assina Termo</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                {dadosModais.cedenteSelecionado.contatos.map((contato) => (
                    <tr key={contato.id}>
                      <td>{contato.nome}</td>
                      <td>{contato.telefone}</td>
                      <td>{contato.email}</td>
                      <td>{contato.recebe_email_cessao ? 'Sim' : 'Não'}</td>
                      <td>{contato.assina_termo ? 'Sim' : 'Não'}</td>
                      <td>
                        <button
                          className="fn-button fn-button--icon fn-button--secondary"
                          onClick={() => abrirModalEdicaoContato(contato)}
                          title="Editar contato"
                        >
                          <div className="fn-button__text">
                            <FontAwesomeIcon icon={faEdit} />
                      </div>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="modal-footer">
              {isAdmin && (
                <button
                  className="fn-button fn-button--emphasized"
                  onClick={abrirModalAdicionarContato}
                >
                  <div className="fn-button__text">
                    <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
                    Adicionar Contato
                  </div>
                </button>
              )}
              <button
                className="fn-button fn-button--emphasized"
                onClick={() => fecharModal('contatos')}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('contatos')}
              >
                <div className="fn-button__text">Fechar</div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.fundos && dadosModais.cedenteFundos && (
        <div className="modal-overlay" onClick={() => fecharModalComConfirmacao('fundos')}>
          <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                Fundos - {dadosModais.cedenteFundos.nome_fantasia}
              </h3>
              <button
                className="modal-close"
                onClick={() => fecharModalComConfirmacao('fundos')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
            <Table>
              <thead>
                <tr>
                    <th>CNPJ</th>
                    <th>Nome</th>
                  <th>Status</th>
                    <th>ID Header CNAB</th>
                    <th>Modelo termo</th>
                    {isAdmin && <th>Ativo</th>}
                  {isAdmin && <th>Ações</th>}
                </tr>
              </thead>
              <tbody>
                {dadosModais.cedenteFundos.fundos.map((fundo) => (
                  <tr key={fundo.id}>
                    <td>{fundo.cnpj}</td>
                    <td>{fundo.nome}</td>
                    <td>
                      <span className={`badge ${fundo.ativo ? 'ativo' : 'inativo'}`}>
                        {fundo.ativo ? 'Ativo' : 'Inativo'}
                      </span>
                    </td>
                      <td>{fundo.id_header_cnab}</td>
                      <td>{ModelosTermo.find(modelo => modelo.id === fundo.modelo_termo)?.nome}</td>
                      {isAdmin && (
                        <td>
                          <label className="checkbox-label">
                            <input
                              type="checkbox"
                              checked={fundo.ativo}
                              onChange={() => toggleStatusFundo(fundo.id)}
                              className="checkbox-input"
                            />
                            <span className="checkbox-text">Ativo</span>
                          </label>
                        </td>
                      )}
                    {isAdmin && (
                      <td>
                        <button
                          className="fn-button fn-button--icon fn-button--secondary"
                          onClick={() => abrirModalEdicaoFundo(fundo)}
                          title="Editar fundo"
                        >
                          <div className="fn-button__text">
                            <FontAwesomeIcon icon={faEdit} />
                          </div>
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
            </div>
            <div className="modal-footer">
              {isAdmin && (
                <button
                  className="fn-button fn-button--emphasized"
                  onClick={abrirModalAdicionarFundo}
                >
                  <div className="fn-button__text">
                    <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
                    Adicionar Fundo
                  </div>
                </button>
              )}
              {isAdmin && (
                <button
                  className="fn-button fn-button--emphasized"
                  onClick={salvarAlteracoesFundos}
                >
                  <div className="fn-button__text">
                    <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                    Salvar
                  </div>
                </button>
              )}
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModalComConfirmacao('fundos')}
              >
                <div className="fn-button__text">Fechar</div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.adicionarContato && (
        <div className="modal-overlay" onClick={() => fecharModal('adicionarContato')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Adicionar Novo Contato</h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('adicionarContato')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Nome</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.novoContato.nome}
                  onChange={(e) => handleInputChange('contato', 'nome', e.target.value)}
                  placeholder="Digite o nome do contato"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-input"
                  value={dadosModais.novoContato.email}
                  onChange={(e) => handleInputChange('contato', 'email', e.target.value)}
                  placeholder="email@exemplo.com"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Telefone</label>
                <input
                  type="tel"
                  className="form-input"
                  value={dadosModais.novoContato.telefone}
                  onChange={(e) => handleInputChange('contato', 'telefone', e.target.value)}
                  placeholder="(11) 3333-4444"
                />
              </div>
              <div className="form-group">
                <label className="checkbox-label">
                <input
                    type="checkbox"
                    checked={dadosModais.dadosEdicaoContato.recebe_email_cessao}
                    onChange={(e) => setDadosModais(prev => ({
                      ...prev,
                      dadosEdicaoContato: { ...prev.dadosEdicaoContato, recebe_email_cessao: e.target.checked }
                    }))}
                    className="checkbox-input"
                  />
                  <span className="checkbox-text">
                    Recebe email de cessão
                    <span
                      className="tooltip-icon"
                      title="Recebe email em caso de erro no processamento da cessão quando recepcionamos o arquivo"
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={dadosModais.dadosEdicaoContato.assina_termo}
                    onChange={(e) => setDadosModais(prev => ({
                      ...prev,
                      dadosEdicaoContato: { ...prev.dadosEdicaoContato, assina_termo: e.target.checked }
                    }))}
                    className="checkbox-input"
                  />
                  <span className="checkbox-text">
                    Assina termo
                    <span
                      className="tooltip-icon"
                      title="Este usuário recebe termo para assinatura da cessão"
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </span>
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('adicionarContato')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarNovoContato}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.adicionarFundo && (
        <div className="modal-overlay" onClick={() => fecharModal('adicionarFundo')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Adicionar Novo Fundo</h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('adicionarFundo')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label form-label--required">Fundo</label>
                <select
                  className="form-input"
                  value={dadosModais.novoFundo.fundo_id}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    novoFundo: { ...prev.novoFundo, fundo_id: parseInt(e.target.value) }
                  }))}
                  required
                >
                  <option value={0}>Selecione um fundo</option>
                  {fundosDisponiveis.map((fundo) => (
                    <option
                      key={fundo.id}
                      value={fundo.id}
                      disabled={isFundoJaAdicionado(fundo.id)}
                    >
                      {fundo.nome} - {fundo.cnpj}
                      {isFundoJaAdicionado(fundo.id) ? ' (Já adicionado)' : ''}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label form-label--required">ID Header CNAB</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.novoFundo.id_header_cnab}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    novoFundo: { ...prev.novoFundo, id_header_cnab: e.target.value }
                  }))}
                  placeholder="Digite o ID Header CNAB"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label form-label--required">ID CNAB</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.novoFundo.id_cnab}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    novoFundo: { ...prev.novoFundo, id_cnab: e.target.value }
                  }))}
                  placeholder="Digite o ID CNAB"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label form-label--required">Modelo Termo</label>
                <select
                  className="form-input"
                  value={dadosModais.novoFundo.modelo_termo}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    novoFundo: { ...prev.novoFundo, modelo_termo: parseInt(e.target.value) }
                  }))}
                  required
                >
                  {ModelosTermo.map((modelo) => (
                    <option key={modelo.id} value={modelo.id}>
                      {modelo.nome}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Situação</label>
                <div className="radio-group">
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="situacaoNovoFundo"
                      value="ativo"
                      checked={dadosModais.novoFundo.ativo === true}
                      onChange={() => setDadosModais(prev => ({
                        ...prev,
                        novoFundo: { ...prev.novoFundo, ativo: true }
                      }))}
                      className="radio-input"
                    />
                    <span className="radio-text">Ativo</span>
                  </label>
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="situacaoNovoFundo"
                      value="inativo"
                      checked={dadosModais.novoFundo.ativo === false}
                      onChange={() => setDadosModais(prev => ({
                        ...prev,
                        novoFundo: { ...prev.novoFundo, ativo: false }
                      }))}
                      className="radio-input"
                    />
                    <span className="radio-text">Inativo</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('adicionarFundo')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarNovoFundo}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.edicao && dadosModais.cedenteParaEdicao && (
        <div className="modal-overlay" onClick={() => fecharModal('edicao')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                Editar Cedente - {dadosModais.cedenteParaEdicao.nome_fantasia}
              </h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('edicao')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Razão Social</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicao.razao_social}
                  onChange={(e) => handleInputChange('edicao', 'razao_social', e.target.value)}
                  placeholder="Digite a razão social"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Nome Fantasia</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicao.nome_fantasia}
                  onChange={(e) => handleInputChange('edicao', 'nome_fantasia', e.target.value)}
                  placeholder="Digite o nome fantasia"
                />
              </div>
              <div className="form-group">
                <label className="form-label">CNPJ</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicao.cnpj}
                  onChange={(e) => handleInputChange('edicao', 'cnpj', e.target.value)}
                  placeholder="00.000.000/0000-00"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Situação</label>
                <div className="radio-group">
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="Situção"
                      value="ativo"
                      checked={dadosModais.dadosEdicao.ativo === true}
                      onChange={() => handleInputChange('edicao', 'ativo', true)}
                      className="radio-input"
                    />
                    <span className="radio-text">Ativo</span>
                  </label>
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="Situção"
                      value="inativo"
                      checked={dadosModais.dadosEdicao.ativo === false}
                      onChange={() => handleInputChange('edicao', 'ativo', false)}
                      className="radio-input"
                    />
                    <span className="radio-text">Inativo</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('edicao')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarEdicao}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.novoCedente && (
        <div className="modal-overlay" onClick={() => fecharModal('novoCedente')}>
          <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Novo Cedente</h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('novoCedente')}
                title="Fechar"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {/* Seção 1: Dados do Cedente */}
              <div className="form-section">
                <h4 className="section-title">Dados do Cedente</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">Razão Social</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.cedente.razao_social ? 'form-input--error' : ''}`}
                      value={dadosModais.novoCedente.razao_social}
                      onChange={(e) => handleInputChange('novoCedente', 'razao_social', e.target.value)}
                      placeholder="Digite a razão social"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Nome Fantasia</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.cedente.nome_fantasia ? 'form-input--error' : ''}`}
                      value={dadosModais.novoCedente.nome_fantasia}
                      onChange={(e) => handleInputChange('novoCedente', 'nome_fantasia', e.target.value)}
                      placeholder="Digite o nome fantasia"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">CNPJ</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.cedente.cnpj ? 'form-input--error' : ''}`}
                      value={dadosModais.novoCedente.cnpj}
                      onChange={(e) => handleInputChange('novoCedente', 'cnpj', e.target.value)}
                      placeholder="00.000.000/0000-00"
                      required
                    />
                  </div>
                  <div className="form-group">
                  </div>
                </div>
              </div>

              {/* Seção 2: Contatos */}
              <div className="form-section">
                <div className="section-header">
                  <h4 className="section-title">Contatos</h4>
                  <button
                    type="button"
                    className="fn-button fn-button--secondary fn-button--icon"
                    onClick={adicionarContatoNovoCedente}
                    title="Adicionar contato"
                  >
                    <div className="fn-button__text">
                      <FontAwesomeIcon icon={faPlus} />
                    </div>
                  </button>
                </div>
                {dadosModais.contatosNovoCedente.map((contato, index) => (
                  <div key={index} className="contact-form-row">
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label form-label--required">Nome</label>
                        <input
                          type="text"
                          className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.contatos[index]?.nome ? 'form-input--error' : ''}`}
                          value={contato.nome}
                          onChange={(e) => atualizarContatoNovoCedente(index, 'nome', e.target.value)}
                          placeholder="Nome do contato"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label form-label--required">Telefone</label>
                        <input
                          type="tel"
                          className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.contatos[index]?.telefone ? 'form-input--error' : ''}`}
                          value={contato.telefone}
                          onChange={(e) => atualizarContatoNovoCedente(index, 'telefone', e.target.value)}
                          placeholder="(11) 99999-9999"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label form-label--required">Email</label>
                        <input
                          type="email"
                          className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.contatos[index]?.email ? 'form-input--error' : ''}`}
                          value={contato.email}
                          onChange={(e) => atualizarContatoNovoCedente(index, 'email', e.target.value)}
                          placeholder="email@exemplo.com"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <button
                          type="button"
                          className="fn-button fn-button--secondary fn-button--icon"
                          onClick={() => removerContatoNovoCedente(index)}
                          title="Remover contato"
                        >
                          <div className="fn-button__text">
                            <FontAwesomeIcon icon={faTimes} />
                          </div>
                        </button>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            checked={contato.recebe_email_cessao}
                            onChange={(e) => atualizarContatoNovoCedente(index, 'recebe_email_cessao', e.target.checked)}
                            className="checkbox-input"
                          />
                          <span className="checkbox-text">
                            Recebe email de cessão
                            <span
                              className="tooltip-icon"
                              title="Recebe email em caso de erro no processamento da cessão quando recepcionamos o arquivo"
                            >
                              <FontAwesomeIcon icon={faInfoCircle} />
                            </span>
                          </span>
                        </label>
                      </div>
                      <div className="form-group">
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            checked={contato.assina_termo}
                            onChange={(e) => atualizarContatoNovoCedente(index, 'assina_termo', e.target.checked)}
                            className="checkbox-input"
                          />
                          <span className="checkbox-text">
                            Assina termo
                            <span
                              className="tooltip-icon"
                              title="Este usuário recebe termo para assinatura da cessão"
                            >
                              <FontAwesomeIcon icon={faInfoCircle} />
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Seção 3: Fundos */}
              <div className="form-section">
                <div className="section-header">
                  <h4 className="section-title">Fundos</h4>
                  <button
                    type="button"
                    className="fn-button fn-button--secondary fn-button--icon"
                    onClick={adicionarFundoNovoCedente}
                    title="Adicionar fundo"
                  >
                    <div className="fn-button__text">
                      <FontAwesomeIcon icon={faPlus} />
                    </div>
                  </button>
                </div>
                {dadosModais.fundosNovoCedente.map((fundo, index) => (
                  <div key={index} className="fund-form-row">
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label form-label--required">Fundo</label>
                        <select
                          className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundos[index]?.fundo_id ? 'form-input--error' : ''}`}
                          value={fundo.fundo_id}
                          onChange={(e) => atualizarFundoNovoCedente(index, 'fundo_id', parseInt(e.target.value))}
                          required
                        >
                          <option value={0}>Selecione um fundo</option>
                          {fundosDisponiveis.map((fundoDisponivel) => (
                            <option
                              key={fundoDisponivel.id}
                              value={fundoDisponivel.id}
                              disabled={isFundoSelecionado(fundoDisponivel.id, index)}
                            >
                              {fundoDisponivel.nome} - {fundoDisponivel.cnpj}
                              {isFundoSelecionado(fundoDisponivel.id, index) ? ' (Já selecionado)' : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <button
                          type="button"
                          className="fn-button fn-button--secondary fn-button--icon"
                          onClick={() => removerFundoNovoCedente(index)}
                          title="Remover fundo"
                        >
                          <div className="fn-button__text">
                            <FontAwesomeIcon icon={faTimes} />
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('novoCedente')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarNovoCedente}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.edicaoContato && dadosModais.contatoParaEdicao && (
        <div className="modal-overlay" onClick={() => fecharModal('edicaoContato')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                Editar Contato - {dadosModais.contatoParaEdicao.nome}
              </h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('edicaoContato')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Nome</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicaoContato.nome}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    dadosEdicaoContato: { ...prev.dadosEdicaoContato, nome: e.target.value }
                  }))}
                  placeholder="Digite o nome do contato"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-input"
                  value={dadosModais.dadosEdicaoContato.email}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    dadosEdicaoContato: { ...prev.dadosEdicaoContato, email: e.target.value }
                  }))}
                  placeholder="email@exemplo.com"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Telefone</label>
                <input
                  type="tel"
                  className="form-input"
                  value={dadosModais.dadosEdicaoContato.telefone}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    dadosEdicaoContato: { ...prev.dadosEdicaoContato, telefone: e.target.value }
                  }))}
                  placeholder="(11) 3333-4444"
                />
              </div>
              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={dadosModais.dadosEdicaoContato.recebe_email_cessao}
                    onChange={(e) => setDadosModais(prev => ({
                      ...prev,
                      dadosEdicaoContato: { ...prev.dadosEdicaoContato, recebe_email_cessao: e.target.checked }
                    }))}
                    className="checkbox-input"
                  />
                  <span className="checkbox-text">
                    Recebe email de cessão
                    <span
                      className="tooltip-icon"
                      title="Recebe email em caso de erro no processamento da cessão quando recepcionamos o arquivo"
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={dadosModais.dadosEdicaoContato.assina_termo}
                    onChange={(e) => setDadosModais(prev => ({
                      ...prev,
                      dadosEdicaoContato: { ...prev.dadosEdicaoContato, assina_termo: e.target.checked }
                    }))}
                    className="checkbox-input"
                  />
                  <span className="checkbox-text">
                    Assina termo
                    <span
                      className="tooltip-icon"
                      title="Este usuário recebe termo para assinatura da cessão"
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </span>
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('edicaoContato')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarEdicaoContato}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.edicaoFundo && dadosModais.fundoParaEdicao && (
        <div className="modal-overlay" onClick={() => fecharModal('edicaoFundo')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                Editar Fundo - {dadosModais.fundoParaEdicao.nome}
              </h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('edicaoFundo')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Nome do Fundo</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicaoFundo.nome}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    dadosEdicaoFundo: { ...prev.dadosEdicaoFundo, nome: e.target.value }
                  }))}
                  placeholder="Digite o nome do fundo"
                />
              </div>
              <div className="form-group">
                <label className="form-label">CNPJ</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicaoFundo.cnpj}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    dadosEdicaoFundo: { ...prev.dadosEdicaoFundo, cnpj: e.target.value }
                  }))}
                  placeholder="00.000.000/0000-00"
                />
              </div>
              <div className="form-group">
                <label className="form-label">ID Header CNAB</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicaoFundo.id_header_cnab}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    dadosEdicaoFundo: { ...prev.dadosEdicaoFundo, id_header_cnab: e.target.value }
                  }))}
                  placeholder="Digite o ID Header CNAB"
                />
              </div>
              <div className="form-group">
                <label className="form-label">ID CNAB</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicaoFundo.id_cnab}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    dadosEdicaoFundo: { ...prev.dadosEdicaoFundo, id_cnab: e.target.value }
                  }))}
                  placeholder="Digite o ID CNAB"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Modelo Termo</label>
                <select
                  className="form-input"
                  value={dadosModais.dadosEdicaoFundo.modelo_termo}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    dadosEdicaoFundo: { ...prev.dadosEdicaoFundo, modelo_termo: parseInt(e.target.value) }
                  }))}
                >
                  {ModelosTermo.map((modelo) => (
                    <option key={modelo.id} value={modelo.id}>
                      {modelo.nome}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Situação</label>
                <div className="radio-group">
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="situacaoFundo"
                      value="ativo"
                      checked={dadosModais.dadosEdicaoFundo.ativo === true}
                      onChange={() => setDadosModais(prev => ({
                        ...prev,
                        dadosEdicaoFundo: { ...prev.dadosEdicaoFundo, ativo: true }
                      }))}
                      className="radio-input"
                    />
                    <span className="radio-text">Ativo</span>
                  </label>
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="situacaoFundo"
                      value="inativo"
                      checked={dadosModais.dadosEdicaoFundo.ativo === false}
                      onChange={() => setDadosModais(prev => ({
                        ...prev,
                        dadosEdicaoFundo: { ...prev.dadosEdicaoFundo, ativo: false }
                      }))}
                      className="radio-input"
                    />
                    <span className="radio-text">Inativo</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('edicaoFundo')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarEdicaoFundo}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.confirmacaoSaida && (
        <div className="modal-overlay" onClick={() => setModais(prev => ({ ...prev, confirmacaoSaida: false }))}>
          <div className="modal-content modal-content--small" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Alterações não salvas</h3>
              <button
                className="modal-close"
                onClick={() => setModais(prev => ({ ...prev, confirmacaoSaida: false }))}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <p>Você tem alterações não salvas. O que deseja fazer?</p>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={descartarAlteracoes}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faXmark} style={{ marginRight: '8px' }} />
                  Descartar alterações
                </div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={confirmarSaida}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                  Salvar e sair
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
    </ErrorBoundary>
  );
};

export default CadastroCedente;